module.exports = {"pageTitleText":"通知对象","createText":"添加","channelName":"名称","channelType":"类型","channelTelegramBotToken":"Bot Token","channelLineBotToken":"Channel Access Token","channelSendTo":"发送地址","channelTest":"測試","sections":{"essential":"基础","advanced":"进阶"}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/notificationChannels.json
// module id = nWzA
// module chunks = 3